/**
 * Site footer with verse copy.
 */
export default function Footer() {
  return (
    <footer className="site-footer">
      <div className="mx-auto max-w-4xl">
        <p className="text-base leading-relaxed text-slate-50">
          “For God so loved the world, that he gave his only begotten Son, that whosoever believeth
          in him should not perish, but have everlasting life.”
        </p>
        <p className="mt-3 font-semibold tracking-wide text-amber-300">John 3:16</p>
      </div>
    </footer>
  );
}
